import { Button } from 'antd'
import { useEJLogContext } from '../../../../../EJLogContext'
import { EngineeringJudgement } from '../../../../../EJLogContext/types'
import { EJStatus } from '@cims-online/shared'

const StatusButton: React.VFC<EngineeringJudgement> = (ej) => {
  const {
    draftSubmitModal: { toggle },
  } = useEJLogContext()
  const { id, name } = EJStatus.fromIdOrFail(ej.statusId)
  return id === EJStatus.Draft.id ? (
    <Button disabled={ej.deleted} type="link" onClick={() => toggle(ej)}>
      {name}
    </Button>
  ) : (
    <>{name}</>
  )
}

export default StatusButton
